import React from "react";
import { Link } from "react-router-dom";
import "./index.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

//Panels
import {SpeakWithDesigner} from "../../../../../CTA/CTA";

//Images
import angelusLogo from "./images/angelus-block-co.png";
import castleCobble1 from "./images/variations-castleCobble1.png";
import castleCobble2 from "./images/variations-castleCobble2.png";
import creamBrownCharcoal from "./images/colors-creamBrownCharcoal.jpg";
import creamTerraCottaBrown from "./images/colors-creamTerraCottaBrown.jpg";
import grayCharcoal from "./images/colors-grayCharcoal.jpg";
import sandStoneMocha from "./images/colors-sandStoneMocha.jpg";
import grayMossCharcoal from "./images/colors-grayMossCharcoal.jpg";
import tuscan from "./images/colors-tuscan.jpg";

const AngelusCastleCobble = () => {
  return (
    <div className="container-fluid no-side-padding page-angelus-castle-cobble">
      <div className="row justify-content-center hero-unit">
        <div className="col-12 no-side-padding">
          <div className="title">
            <Link to="/services/driveways">
              <FontAwesomeIcon icon={faChevronLeft} /> back to pavers
            </Link>
            <h1>Angelus Castle Cobble</h1>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-11 col-xl-10">
          <div className="row justify-content-center panel-description mt-5 mb-5 pb-5">
            <div className="col-12 col-md-6 text-center">
              <img src={angelusLogo} alt="Angelus Block Co" />
              <p className="mt-3">
                A versatile cobble in the Natural Collection with teh rustic
                ambiance of natural stone. Castle Cobble is a tumbled,
                non-chamfered stone, providing beautiful inviting character in
                any setting.
              </p>
            </div>
          </div>
          <div className="row justify-content-center mt-5 mb-5 pb-5 panel-variations">
            <div className="col-12 text-uppercase text-center mb-5">
              <h3 className="text-blue">Variations</h3>
            </div>
            <div className="col-6 col-md-4 text-center">
              <img src={castleCobble1} alt="Castle Cobble 1" />
              <p className="mt-3 text-uppercase">
                Castle Cobble I (Distressed)
                <br />
                60mm
              </p>
            </div>
            <div className="col-6 col-md-4 text-center">
              <img src={castleCobble2} alt="Castle Cobble 2" />
              <p className="mt-3 text-uppercase">
                Castle Cobble II (Distressed)
                <br />
                60mm
              </p>
            </div>
          </div>
          <div className="row justify-content-center pb-5 panel-colors">
            <div className="col-12 text-center text-uppercase">
              <h3 className="text-blue mb-5">Colors</h3>
            </div>
            <div className="col-10 col-md-5 col-lg-4 text-center">
              <img src={creamBrownCharcoal} alt="Cream - Brown - Charcoal"/>
              <p className="text-uppercase mt-3">Cream - Brown - Charcoal</p>
            </div>
            <div className="col-10 col-md-5 col-lg-4 text-center">
              <img src={creamTerraCottaBrown} alt="Cream - Terra Cotta - Brown"/>
              <p className="text-uppercase mt-3">Cream - Terra Cotta - Brown</p>
            </div>
            <div className="col-10 col-md-5 col-lg-4 text-center">
              <img src={grayCharcoal} alt="Gray - Charcoal"/>
              <p className="text-uppercase mt-3">Gray - Charcoal</p>
            </div>
            <div className="col-10 col-md-5 col-lg-4 text-center">
              <img src={sandStoneMocha} alt="Sand - Stone - Mocha"/>
              <p className="text-uppercase mt-3">Sand - Stone - Mocha</p>
            </div>
            <div className="col-10 col-md-5 col-lg-4 text-center">
              <img src={grayMossCharcoal} alt="Gray - Moss - Charcoal"/>
              <p className="text-uppercase mt-3">Gray - Moss - Charcoal</p>
            </div>
            <div className="col-10 col-md-5 col-lg-4 text-center">
              <img src={tuscan} alt="Tuscan"/>
              <p className="text-uppercase mt-3">Tuscan</p>
            </div>
          </div>
          <div className="row justify-content-center mt-5 mb-5 panel-disclaimer">
            <div className="col-11 col-md-10 text-center disclaimer-wrapper">
              <p>All color images are intended to be representative only. Colors as shown are subject to media variation in reproduction. Variation in color, shades of color, texture, and aggregate exposure is inherent in all concrete products and exact matches cannot be guaranteed. A color may not be available from all locations. Availability of colors or textures as &quot;stock&quot; or &quot;special order&quot; is subject to change without notice. Always view samples with prior installation.</p> 
            </div>
          </div>
        </div>
      </div>
      <SpeakWithDesigner/>
    </div>
  );
};

export default AngelusCastleCobble;
